import React, { useState, ChangeEvent, FormEvent } from "react"

const LoginCred = () => {
  const [logininfo, setLogininfo] = useState({
    email: "email",
    current_password: "",
    new_password: "",
    repeat_password: "",
  })

  const onChange = (e: ChangeEvent) => {
    setLogininfo({
      ...logininfo,
      [e.target.id]: e.target.nodeValue,
    })
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    console.log(logininfo)
  }

  return (
    <form
      onSubmit={onSubmit}
      className=" bg-dark uk-padding-small uk-border-rounded uk-width-3-5@m uk-width-5-6@s"
    >
      <div className="uk-margin-small-bottom">
        <label className="uk-form-label app-text">Email</label>
        <input
          type="email"
          className="uk-input"
          onChange={onChange}
          id="email"
          placeholder="Email"
        />
      </div>
      <div className="uk-margin-small-bottom">
        <label className="uk-form-label app-text">Current password</label>
        <input
          type="password"
          className="uk-input"
          onChange={onChange}
          id="current_password"
          placeholder="Password"
        />
      </div>
      <div className="uk-margin-small-bottom">
        <label className="uk-form-label app-text">New password</label>
        <input
          type="password"
          className="uk-input"
          onChange={onChange}
          id="new_password"
          placeholder="Password"
        />
      </div>
      <div className="uk-margin-small-bottom">
        <label className="uk-form-label app-text">Repeat password</label>
        <input
          type="password"
          className="uk-input"
          onChange={onChange}
          id="repeat_password"
          placeholder="Password"
        />
      </div>

      <div className="uk-margin-small-top uk-flex-center">
        <button className="uk-button uk-border-rounded">Update</button>
      </div>
    </form>
  )
}

export default LoginCred
